import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["mainBlock", "settingsBlock", "functionalCheckbox", "analyticalCheckbox", "marketingCheckbox"]

  connect() {
    // Проверяем, было ли уже дано согласие
    if (!this.hasConsent()) {
      // Показываем баннер сразу
      this.showBanner()
    }
  }

  hasConsent() {
    // Проверяем наличие куки с согласием
    return this.getCookie("cookie_consent") !== null
  }

  showBanner() {
    // Используем сам элемент контроллера
    const banner = this.element

    // Показываем баннер
    banner.style.display = "block"
    banner.style.opacity = "0"
    banner.style.transition = "opacity 0.3s ease-in"

    // Плавное появление
    requestAnimationFrame(() => {
      setTimeout(() => {
        banner.style.opacity = "1"
      }, 10)
    })
  }

  hideBanner() {
    const banner = this.element

    banner.style.transition = "opacity 0.3s ease-out"
    banner.style.opacity = "0"

    setTimeout(() => {
      banner.style.display = "none"
    }, 300)
  }

  showSettings() {
    this.mainBlockTarget.classList.add("hidden")
    this.settingsBlockTarget.classList.remove("hidden")
  }

  hideSettings() {
    this.settingsBlockTarget.classList.add("hidden")
    this.mainBlockTarget.classList.remove("hidden")
  }

  acceptAll() {
    // Сохраняем согласие на все категории
    this.setCookie("cookie_consent", "all", 365)
    this.setCookie("cookie_functional", "true", 365)
    this.setCookie("cookie_analytical", "true", 365)
    this.setCookie("cookie_marketing", "true", 365)

    // Скрываем баннер
    this.hideBanner()
  }

  saveSettings() {
    // Сохраняем выбранные категории
    const functional = this.functionalCheckboxTarget.checked
    const analytical = this.analyticalCheckboxTarget.checked
    const marketing = this.marketingCheckboxTarget.checked

    // Функциональные всегда включены
    this.setCookie("cookie_functional", "true", 365)

    // Сохраняем остальные категории
    if (analytical) {
      this.setCookie("cookie_analytical", "true", 365)
    } else {
      this.setCookie("cookie_analytical", "false", 365)
    }

    if (marketing) {
      this.setCookie("cookie_marketing", "true", 365)
    } else {
      this.setCookie("cookie_marketing", "false", 365)
    }

    // Сохраняем общее согласие
    this.setCookie("cookie_consent", "custom", 365)

    // Скрываем баннер
    this.hideBanner()
  }

  toggleCategory(event) {
    // Обновляем состояние чекбокса при изменении
    // Логика уже обрабатывается в saveSettings
  }

  setCookie(name, value, days) {
    const date = new Date()
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000))
    const expires = "expires=" + date.toUTCString()
    document.cookie = name + "=" + value + ";" + expires + ";path=/"
  }

  getCookie(name) {
    const nameEQ = name + "="
    const ca = document.cookie.split(";")
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i]
      while (c.charAt(0) === " ") c = c.substring(1, c.length)
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length)
    }
    return null
  }
}
